import { useEffect, useRef, useState } from "react";
import { fetchUsers, updateUserRoles, removeUser, fetchApprovals, approveUser, rejectUser } from "./Helpers";
import { error, info } from '@refinitiv-ui/elements/notification';

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [pUsers, setPUsers] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const [pApprovals, setPApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userToDelete, setUserToDelete] = useState(null);
  const [approvalsUi, setApprovalsUi] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkedStates, setCheckedStates] = useState([]);
  const labelText = useRef("");

  function searchEvent(val) {   
    let searchString = "";
    if(approvalsUi){
      setPApprovals(approvals.filter(item => {
        searchString = item[8].toLowerCase()+" "+item[7].toLowerCase();
        return searchString.includes(val.toLowerCase());
      }));
    }else{  
      setPUsers(users.filter(item => {
        searchString = item.first.toLowerCase()+" "+item.last.toLowerCase();
        return searchString.includes(val.toLowerCase());
      }));
    }
  }


  function transformData(rawUsers) {
    return rawUsers.map(user => {
      user.editMode = false;
      return user;
    });
  }

  function enableEditMode(index, flag, success=false) {
    if(flag){
      let roles = [];
      const checkboxes = document.querySelectorAll(`#user-layout-${index} ef-checkbox`);
      checkboxes.forEach(checkbox => {
        roles.push(checkbox.checked);
      });
      setCheckedStates(roles);
    }else if(!flag && !success){
      const checkboxes = document.querySelectorAll(`#user-layout-${index} ef-checkbox`);
      checkboxes.forEach((checkbox, i) => {
        checkbox.checked = checkedStates[i];
      });
    }
    const updatedUsers = users.map((user, i) => {
      if (i === index) {
        user.editMode = flag;
      }
      return user;
    });
    setUsers(updatedUsers);
  }

  function revokeUser(userID, index) {
    setLoading(true);
    let roles = [];
    const checkboxes = document.querySelectorAll(`#user-layout-${index} ef-checkbox`);
    checkboxes.forEach(checkbox => {
      roles.push(checkbox.checked);
    });
    if(!roles.includes(true)){
      setLoading(false);
      info("At least one role should be selected, if you want to revoke all roles, please delete the user instead.", 5000);
      return;
    }
    updateUserRoles(userID, roles).then(response => {
      setLoading(false);
      if (response && response.d) {
        info("User roles updated successfully", 5000);
        enableEditMode(index, false, true);
      }
      else{
        error("Failed to update user roles", 5000);
        enableEditMode(index, false, false);
      }
    });
  }

  function formatShortDate(timestamp) {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric"
    });
  }

  function userApproval(userID, index) {
    setLoading(true);
    approveUser(userID).then(response => {
      setLoading(false);
      if (response && response.d) {
        info("User role approved successfully", 5000);
        const updatedApprovals = approvals.filter((approval) => approval[0] !== index);
        setApprovals(updatedApprovals);
      } else {
        error("Failed to approve user role", 5000);
      }
    });
  }

  function userDeny(userID, index) {
    setLoading(true);
    rejectUser(userID).then(response => {
      setLoading(false);
      if (response && response.d) {
        info("User role rejected successfully", 5000);
        const updatedApprovals = approvals.filter((approval) => approval[0] !== index);
        setApprovals(updatedApprovals);
      }
    });
  }

  function paginateUsers(val) {
    let newPage = val === "next" ? currentPage + 1 : currentPage - 1;
    if(newPage < 1 || newPage > Math.ceil(users.length / recordsPerPage)){
      return;
    }
    setPUsers(users.slice((newPage - 1) * recordsPerPage, newPage * recordsPerPage));
    setCurrentPage(newPage);
    labelText.current = `Page ${newPage} of ${Math.ceil(users.length / recordsPerPage)}`;
  }

  function paginateApprovals(val) {
    let newPage = val === "next" ? currentPage + 1 : currentPage - 1;
    if(newPage < 1 || newPage > Math.ceil(approvals.length / recordsPerPage)){
      return;
    }
    setPApprovals(approvals.slice((newPage - 1) * recordsPerPage, newPage * recordsPerPage));
    setCurrentPage(newPage);
    labelText.current = `Page ${newPage} of ${Math.ceil(approvals.length / recordsPerPage)}`;
  }

  useEffect(() => {
    function deleteUser(userId) {
      setLoading(true);
      removeUser(userId).then(response => {
        setLoading(false);
        if (response && response.d) {
          info("User deleted successfully", 5000);
          const updatedUsers = users.filter((user) => user.id !== userId);
          setUsers(updatedUsers);
        }
      });
    }

    const dialog = document.getElementById("dlg1");
    if (dialog) {
      if (userToDelete) {
        dialog.opened = true;
      } else {
        dialog.opened = false;
      }
      dialog.addEventListener("cancel", (event) => {
        if (!event.target.opened) {
          setUserToDelete(null);
        }
      });
      dialog.addEventListener("confirm", (event) => {
        if (userToDelete) {
          deleteUser(userToDelete.id);
          setUserToDelete(null);
        }
      });
    }
  }, [userToDelete, users]);

  useEffect(() => {
    fetchUsers().then(fetchedUsers => {
      if (fetchedUsers.length > 0) {
        setUsers(transformData(fetchedUsers));
        setPUsers(transformData(fetchedUsers).slice(0, 10));
        labelText.current = `Page 1 of ${Math.ceil(fetchedUsers.length / 10)}`;
        setLoading(false);
      }
    });
    fetchApprovals().then(fetchedApprovals => {
      setApprovals(fetchedApprovals);
    });
  }, []);

  useEffect(() => {
    if(!approvalsUi){
      const selectElement = document.getElementById("records-per-page");
      if (selectElement) {     
        selectElement.addEventListener("value-changed", (event) => {
          const newRecordsPerPage = parseInt(event.target.value);
          setRecordsPerPage(newRecordsPerPage);
          setPUsers(users.slice(0, newRecordsPerPage));
          setCurrentPage(1);
          labelText.current = `Page 1 of ${Math.ceil(users.length / newRecordsPerPage)}`;
        });
      }
    }
  }, [users, approvalsUi]);

  useEffect(() => {
    if(approvalsUi){
      setPApprovals(approvals.slice(0, recordsPerPage));
      setCurrentPage(1);
      labelText.current = `Page 1 of ${Math.ceil(approvals.length / recordsPerPage)}`;
    }else{
      setPUsers(users.slice(0, recordsPerPage));
      setCurrentPage(1);
      labelText.current = `Page 1 of ${Math.ceil(users.length / recordsPerPage)}`;
    }
  }, [approvalsUi, approvals, recordsPerPage, users]);

  useEffect(() => {
    if(approvalsUi){
      const selectElement = document.getElementById("records-per-page-approvals");
      if (selectElement) {     
        selectElement.addEventListener("value-changed", (event) => {
          const newRecordsPerPage = parseInt(event.target.value);
          setRecordsPerPage(newRecordsPerPage);
          setPApprovals(approvals.slice(0, newRecordsPerPage));
          setCurrentPage(1);
          labelText.current = `Page 1 of ${Math.ceil(approvals.length / newRecordsPerPage)}`;
        });
      }
    }
  }, [approvals, approvalsUi]);

  return (
    <div className="user-management-page">
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <ef-dialog id="dlg1" header="Remove User">
        <p>Remove the User <b>{userToDelete?.first} {userToDelete?.last}</b>?</p>
      </ef-dialog>
      <h4>User Management</h4>
      <ef-layout className="search-layout">
        <input
          className='search-field'
          type="text"
          placeholder="Type to search..."
          onChange={(e) => searchEvent(e.target.value)}
        />
      </ef-layout>
      <ef-tab-bar level="3">
        <ef-tab label="Users" value="tab1" onClick={() => setApprovalsUi(false)} active></ef-tab>
        <ef-tab label="Approvals" value="tab2" onClick={() => setApprovalsUi(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="user-mgmnt-parent-layout">
        {!approvalsUi && pUsers.map((user,index) => (
          <ef-layout key={index} id={`user-layout-${index}`} className="user-mgmnt-layout">
            <div className="user-mgmnt-div user-mgmnt-div-underline">
              <span>{user.first} {user.last}</span>
              <ef-button onClick={() => setUserToDelete(user)}><ef-icon icon="trash"></ef-icon></ef-button>
            </div>
            <div className="user-mgmnt-div">
              <ef-checkbox checked={user.roles.includes(67032)} disabled={!user.editMode}></ef-checkbox>
              <span>Owner Role</span>
              <ef-checkbox checked={user.roles.includes(67036)} disabled={!user.editMode}></ef-checkbox>
              <span>Admin Role</span>
              <ef-checkbox checked={user.roles.includes(69018)} disabled={!user.editMode}></ef-checkbox>
              <span>User Role</span>
              { !user.editMode && <ef-button onClick={() => enableEditMode(index, true)}><ef-icon icon="edit"></ef-icon></ef-button> }
              { user.editMode && <ef-button onClick={() => enableEditMode(index, false)}><ef-icon icon="refresh"></ef-icon></ef-button> }
              { user.editMode && <ef-button onClick={() => revokeUser(user.id, index)}><ef-icon icon="tick"></ef-icon></ef-button> }
            </div>
          </ef-layout>
        ))}
        {approvalsUi && pApprovals.map((approval,index) => (
          <ef-layout key={index} className="user-mgmnt-layout">
            <div className="user-mgmnt-div">
              <span>{formatShortDate(approval[9])}</span>&nbsp;&nbsp;
              <span>User <b>{approval[8]}({approval[7]})</b> is applying for role <b>{approval[2]}</b></span>
              <ef-button onClick={() => userDeny(approval[6], approval[0])}><ef-icon icon="void"></ef-icon></ef-button>
              <ef-button onClick={() => userApproval(approval[6], approval[0])}><ef-icon icon="tick"></ef-icon></ef-button>
            </div>
          </ef-layout>
        ))}
        {approvalsUi && approvals.length === 0 && (
          <ef-layout>
            <div className="user-mgmnt-div">
              <span>No pending approvals</span>
            </div>
          </ef-layout>
        )}
        {!approvalsUi && users.length > 10 && (
          <ef-layout flex className="pagination-layout">
            <ef-layout>
              Show 
              <ef-select id="records-per-page">
                <ef-item value="10" selected>10</ef-item>
                <ef-item value="20">20</ef-item>
                <ef-item value="50">50</ef-item>
              </ef-select>
              Records</ef-layout>
            <ef-layout>
              <ef-button onClick={() => paginateUsers("next")}>Next</ef-button>
              <ef-button onClick={() => paginateUsers("previous")}>Previous</ef-button>
              <ef-label>{labelText.current}</ef-label>
            </ef-layout>
          </ef-layout>
        )}
        {approvalsUi && approvals.length > 10 && (
          <ef-layout flex className="pagination-layout">
            <ef-layout>
              Show 
              <ef-select id="records-per-page-approvals">
                <ef-item value="10" selected>10</ef-item>
                <ef-item value="20">20</ef-item>
                <ef-item value="50">50</ef-item>
              </ef-select>
              Records</ef-layout>
            <ef-layout>
              <ef-button onClick={() => paginateApprovals("next")}>Next</ef-button>
              <ef-button onClick={() => paginateApprovals("previous")}>Previous</ef-button>
              <ef-label>{labelText.current}</ef-label>
            </ef-layout>
          </ef-layout>
        )}
      </ef-layout>
    </div>
  );
}